import { render } from "./Home.vue?vue&type=template&id=fda6e148&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=fda6e148&lang=scss"
import "./Home.vue?vue&type=style&index=1&id=fda6e148&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-fda6e148"

export default script